import yup from 'core/utils/validators';
import { FIELD_REQUIRED } from 'const';

const { object, string, boolean } = yup;

export const panCardNumberFormSchema = () =>
  object().shape({
    pan_card_number: string().min(12, 'Incorrect code').required(FIELD_REQUIRED),
    is_confirmed: boolean()
      .isTrue('message_is_is_credit_bureau_consent_given')
      .required('message_is_credit_bureau_consent_given'),
  });
